export const LOAD_SET = 'LOAD_SET';

export const CAR_BRAND_GET = 'CAR_BRAND_GET';
export const CAR_MODEL_GET = 'CAR_MODEL_GET';

export const INSURE_GET = 'INSURE_GET';
export const INSURE_SET = 'INSURE_SET';
export const INSURE_UPDATE = 'INSURE_UPDATE';
